import { get } from 'lodash';

const ACTIONS = {
    OPEN_EXPORT_WIZARD_MODAL: 'OPEN_EXPORT_WIZARD_MODAL',
    CLOSE_EXPORT_WIZARD_MODAL: 'CLOSE_EXPORT_WIZARD_MODAL',
};

const initialState = {
    luceneCode: "",
    isModalOpened: false,
};

export default (state = initialState, action) => {
    
    switch (action.type) {
        case ACTIONS.OPEN_EXPORT_WIZARD_MODAL: {
            return { ...state, luceneCode: get(action, 'payload.luceneCode'), isModalOpened: true };
        }

        case ACTIONS.CLOSE_EXPORT_WIZARD_MODAL: {
            return { ...state, luceneCode: "", isModalOpened: false };
        }


        default: {
            return state;
        }
    }
};

export const openExportWizardModal = (payload) => ({
    type: ACTIONS.OPEN_EXPORT_WIZARD_MODAL,
    payload,
});

export const closeExportWizardModal = (payload) => ({
    type: ACTIONS.CLOSE_EXPORT_WIZARD_MODAL,
    payload,
});

